var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    [
      _c("mini-header", {
        attrs: {
          title: "Reportes",
          dense: true,
          breadcrumbs: _vm.breadcrumbs,
          hiddenTab: true,
        },
      }),
      _c(
        "v-col",
        { staticClass: "px-0 mt-5", attrs: { cols: "12" } },
        [
          _vm.reportsList.length
            ? _c(
                "v-row",
                _vm._l(_vm.reportsList, function (report, i) {
                  return _c(
                    "v-col",
                    {
                      key: i,
                      staticStyle: { "max-width": "240px" },
                      attrs: { cols: "2" },
                    },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "px-5 py-7",
                          attrs: {
                            height: "80",
                            "min-width": "220",
                            "max-width": "220",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.goToReport(report)
                            },
                          },
                        },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "fill-height ma-0 text-left",
                              attrs: { align: "center" },
                            },
                            [
                              _c("v-img", {
                                staticStyle: { position: "absolute" },
                                attrs: {
                                  contain: "",
                                  height: 44,
                                  src: require(`@/assets/shortcuts-icons/avatars/${report.icon}--avatar.svg`),
                                },
                              }),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "grey-700--text font-weight-bold ml-14 pl-2 mt-n1",
                                  class:
                                    _vm.$vuetify.breakpoint.width <= 1200
                                      ? "body-2"
                                      : "subtitle-2",
                                },
                                [_vm._v(_vm._s(report.title))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              )
            : _vm.countryReports.length
            ? _c("PermissionDenied")
            : _c("v-empty-state", {
                attrs: {
                  type: "documents",
                  id: "reportes",
                  height: 320,
                  customClass: "mt-8",
                  isFree: true,
                  title: "No tienes reportes disponibles",
                  description: "No hay reportes disponibles para tu país",
                },
              }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }